import { useState } from 'react';
import { GridSortModel } from '@mui/x-data-grid';

export type ServerSortParams = {
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
};

/**
 * Sort state for a server-paged `CommonDataGrid`. Spread `sortParams` into the
 * list query and pass `gridSortProps` to the grid. `onSortChange` runs when the
 * sort changes, e.g. to jump back to the first page.
 */
export const useServerSort = (onSortChange?: () => void) => {
  const [sortModel, setSortModel] = useState<GridSortModel>([]);
  const [first] = sortModel;
  const sortParams: ServerSortParams = first?.sort
    ? { sortBy: first.field, sortOrder: first.sort }
    : {};

  const onSortModelChange = (model: GridSortModel) => {
    setSortModel(model);
    onSortChange?.();
  };

  return { sortParams, gridSortProps: { sortModel, onSortModelChange } };
};
